// extracted by mini-css-extract-plugin
export default {"imgWrapperTab":"index_imgWrapperTab_dnFpD","tab":"index_tab_QX4y4"};